
import { defineComponent } from "vue";

declare global {
  interface Window {
    fitText: any;
  }
}

window.fitText = window.fitText || {};

export default defineComponent({
  name: "Notepad",
  props: {
    color: {
      type: String,
      required: true
    },
    highlightColor: {
      type: String,
      required: true
    },
    width: [Number, String],
    height: [Number, String],
    content: String,
    link: String
  },
  data: () => ({
    observer: {} as MutationObserver
  }),
  // mounted() {
  //   this.observer = new MutationObserver((mutations) => {
  //     for (const m of mutations) {
  //       // console.log((m.target as HTMLElement).clientWidth);
  //       this.$nextTick().then(() => {
  //         window.fitText();
  //       });
  //     }
  //   });

  //   this.observer.observe(this.$el, {
  //     attributes: true,
  //     attributeOldValue: true,
  //     attributeFilter: ["style"]
  //   });
  // }
  mounted: function() {
    window.fitText(
      (this.$el as HTMLElement).childNodes[0]?.childNodes[0],
      this.width,
      1.3
    );
  }
});
